import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { withProcedureWraper } from "../../../../..";
import {
  BoxSection,
  ApprovalHistory,
  Chats,
  ButtonList,
  Loading,
  Error,
  NPSteps,
  Box,
  FileList,
} from "../../../../../../../components";
import { useAFLRequest, useAFLSteps, useUpdateAFL } from "../../../hooks";
import { AFLType } from "../../../models";
import { RequestStatus } from "../../../../../../../constants";
import { StringHelper } from "../../../../../../../helper";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { getBackLink, getDetailTemplate, getSiteUrl } from "../../../utils";
import { aflTypeShortLabel } from "../../../constants";
import { notification } from "antd";

const requestFallback = {};

const AbsenceLetterDetail = withProcedureWraper(() => {
  const history = useHistory();
  const [reason, setReason] = useState("");

  const {
    data: request = requestFallback,
    isLoading: isRequestLoading,
    isFetching: isRequestFetching,
    isError,
  } = useAFLRequest();

  const [aflType] = StringHelper.verticalBarSplit(request?.eAFLType);
  const { mutate, updateApplicationForLeave } = useUpdateAFL();
  const { getNewSteps, process, getCurrent, notify, notifyAnother, getHistories } = useAFLSteps();
  const { pathname } = useLocation();

  const siteUrl = getSiteUrl(aflType, pathname);
  const backLink = getBackLink(aflType, pathname);

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  const {
    eApprovalProcess: { current, status },
    eSteps,
    eComments,
    eRequestStatus,
  } = request;

  const { canApprove, canEdit, canCancel } = process({
    current: request.eApprovalProcess.current,
    steps: request.eSteps,
    eRequestStatus: request.eRequestStatus,
  });

  const approvalHistory = getHistories(eSteps);

  const onApproveClick = () => {
    const newSteps = getNewSteps(eSteps, current + 1, "approve", reason);
    const newCurrent = getCurrent(newSteps[current + 1], current);
    const isFinished = newCurrent + 1 === eSteps.length;
    const vars = {
      id: request.id,
      body: {
        eSteps: newSteps,
        eRequestStatus: isFinished ? RequestStatus.completed : eRequestStatus,
        eApprovalProcess: {
          current: getCurrent(newSteps[current + 1], current),
          status: "finish",
        },
      },
    };

    updateApplicationForLeave(vars, {
      onSuccess(response: any = {}) {
        const { id, eRequestStatus, eRequestName, eEmail } = response;
        const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;
        notifyFn({
          steps: JSON.parse(response.eSteps),
          toPath: `${siteUrl}/${id}`,
          eRequestStatus,
          current: JSON.parse(response.eApprovalProcess).current,
          requestUser: { name: eRequestName, email: eEmail },
          reason,
          aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
        });
      },
    });
  };

  const onRejectClick = () => {
    if (!reason) {
      notification.warning({
        message: "Thông báo!",
        description: `Vui lòng nhập lý do.`,
      });
      return;
    }
    const newSteps = getNewSteps(eSteps, current + 1, "reject", reason);

    const vars = {
      id: request.id,
      body: {
        eSteps: newSteps,
        eRequestStatus: RequestStatus.rejected,
        eApprovalProcess: {
          current: getCurrent(newSteps[current + 1], current),
          status: "error",
        },
      },
    };
    updateApplicationForLeave(vars, {
      successText: "Từ chối yêu cầu thành công",
      errorText: "Từ chối yêu cầu thất bại",
      onSuccess(response: any) {
        const { id, eRequestStatus, eRequestName, eEmail } = response;
        const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;

        notifyFn({
          steps: JSON.parse(response.eSteps),
          toPath: `${siteUrl}/${id}`,
          eRequestStatus,
          current: JSON.parse(response.eApprovalProcess).current,
          requestUser: { name: eRequestName, email: eEmail },
          reason,
          aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
        });
      },
    });
  };

  const onCancelClick = () => {
    const newSteps = getNewSteps(eSteps, 0, "cancel");
    const vars = {
      id: request.id,
      body: {
        eSteps: newSteps,
        eRequestStatus: RequestStatus.canceled,
        eApprovalProcess: {
          current: 0,
          status: "finish",
        },
      },
    };
    updateApplicationForLeave(vars, {
      successText: "Huỷ bỏ yêu cầu thành công",
      errorText: "Huỷ bỏ yêu cầu thất bại",
      onSuccess(response: any) {
        const { id, eRequestStatus, eRequestName, eEmail } = response;
        const notifyFn = aflType === AFLType.ApplicationForLeave ? notify : notifyAnother;
        notifyFn({
          steps: JSON.parse(response.eSteps),
          toPath: `${siteUrl}/${id}`,
          eRequestStatus,
          current: JSON.parse(response.eApprovalProcess).current,
          requestUser: { name: eRequestName, email: eEmail },
          reason,
          aflTypeLabel: aflTypeShortLabel[aflType as AFLType],
        });
      },
    });
  };

  const TemplateDetail = getDetailTemplate(aflType);

  return (
    <ProcedureLayout title="XEM XÉT YÊU CẦU DUYỆT" loading={isRequestFetching} backLink={backLink}>
      <Box title="Quy trình duyệt">
        <NPSteps current={current} status={status} items={eSteps} />
      </Box>
      <Box title="Thông tin">
        <TemplateDetail data={request} />

        {/* {medicalStaffAFLTypes.includes(aflType) && (
          <BoxSection title="Thông tin giám định">
            <InspectionInformation data={request} />
          </BoxSection>
        )} */}

        <BoxSection title="Tệp đính kèm">
          <FileList files={request.eAttachments} />
        </BoxSection>
        <BoxSection title="Lịch sử phê duyệt">
          <ApprovalHistory showComment={canApprove} items={approvalHistory} value={reason} onChange={setReason} />
        </BoxSection>
        <BoxSection title="Thông tin trao đổi">
          <Chats requestId={request.id} items={eComments} mutateFn={mutate} />
        </BoxSection>
        <div className="flex-center">
          <ButtonList
            items={[
              {
                buttonType: "success",
                label: "Đồng ý",
                onClick: onApproveClick,
                hidden: !canApprove,
              },
              {
                buttonType: "grey",
                label: "Không đồng ý",
                onClick: onRejectClick,
                hidden: !canApprove,
              },
              {
                buttonType: "warning",
                label: "Chỉnh sửa",
                hidden: !canEdit,
                onClick: () => history.push(`${backLink}/${request.id}/edit`),
              },
              {
                buttonType: "danger",
                label: "Huỷ bỏ",
                hidden: !canCancel,
                onClick: onCancelClick,
              },
            ]}
          />
        </div>
      </Box>
    </ProcedureLayout>
  );
});

export default AbsenceLetterDetail;
